export const getLegendValue = (seriesName, opts, properties) => {
  let legend = seriesName
  let serieIndex = opts.seriesIndex
  let legendConfig = properties?.legend
  let showValue = legendConfig?.showValue
  let showPercent = legendConfig?.showPercent
  if (showValue) {
    let prefixValue = legendConfig?.prefixValue || ``
    let suffixValue = legendConfig?.suffixValue || ``
    let serie = opts.w.globals.series[serieIndex]
    legend += prefixValue + serie + suffixValue + ` `
  }
  if (showPercent) {
    let prefixPercent = legendConfig?.prefixPercent || ``
    let suffixPercent = legendConfig?.suffixPercent || ``
    let percent = opts.w.globals.seriesPercent[serieIndex][0]
    legend += prefixPercent + percent.toFixed(1) + `%` + suffixPercent
  }
  return legend
}

export const getLegend = (chartKey, properties) => {
  let legendValue = ['donut', 'pie']
  if (legendValue.includes(chartKey)) {
    return {
      formatterKey: `legend.formatter`,
      formatter: (seriesName, opts) =>
        getLegendValue(seriesName, opts, properties),
    }
  }
  return null
}
